<template>
  <iModal
    v-if="visible"
    :close-on-backdrop="!isUploading"
    :close-on-escape="!isUploading"
    :max-width="500"
    title="Upload Cover Image"
    primary-action-button-label="Save"
    :primary-action-button-loading="isUploading"
    :primary-action-button-disabled="!imagePreview"
    @close="handleClose"
    @click:primary="handleSave"
  >
    <template #body>
      <iColumn gap="standard" width="fill">
        <iImageUploader
          :image="imagePreview || currentCoverImage"
          change-image-text="Change Cover Image"
          select-image-text="Select Cover Image"
          button-variant="secondary"
          @upload-image="handleImageSelected"
        />
      </iColumn>
    </template>
  </iModal>
</template>

<script>
export default {
  name: "AudioCoverImageModal",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    currentCoverImage: {
      type: String,
      default: null,
    },
    uploadFunction: {
      type: Function,
      required: true,
    },
  },
  emits: ["close", "save"],
  data() {
    return {
      selectedFile: null,
      imagePreview: null,
      isUploading: false,
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.imagePreview = this.currentCoverImage ?? null;
        return;
      }
      this.resetState();
    },
  },
  methods: {
    handleImageSelected(file) {
      if (this.imagePreview && this.imagePreview !== this.currentCoverImage) {
        URL.revokeObjectURL(this.imagePreview);
      }
      this.selectedFile = file;
      this.imagePreview = URL.createObjectURL(file);
    },
    async handleSave() {
      this.isUploading = true;
      let coverImageUrl = this.currentCoverImage;
      if (this.selectedFile) {
        coverImageUrl = await this.uploadFunction(this.selectedFile);
      }
      this.$emit("save", coverImageUrl);
    },
    handleClose() {
      this.$emit("close");
      this.resetState();
    },
    resetState() {
      if (this.imagePreview && this.imagePreview !== this.currentCoverImage) {
        URL.revokeObjectURL(this.imagePreview);
      }
      this.selectedFile = null;
      this.imagePreview = null;
      this.isUploading = false;
    },
  },
};
</script>
